/* Add one non-recurring kit before checkout. Never retry an uncertain write. */
window.HenceStarterPack ||= (() => {
  let pending = false;
  let reviewRequired = false;
  const read = async (url) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('We could not check the Starter Pack. Please try again.');
    return response.json();
  };
  return {
    async add({ root, kit, variantId, productId, quantity }) {
      if (pending || reviewRequired) {
        const error = new Error('Review your basket before adding more items.');
        error.reviewRequired = reviewRequired;
        throw error;
      }
      pending = true;
      let attempted = false;
      try {
        if (!Number.isSafeInteger(variantId) || !Number.isSafeInteger(productId) ||
            !Number.isInteger(quantity) || quantity < 1 || quantity > 3 ||
            !kit || !Number.isSafeInteger(kit.id) || kit.price !== 1000 || kit.id === variantId) {
          throw new Error('This Starter Pack selection is unavailable.');
        }
        const [product, before] = await Promise.all([
          read(`${root}products/${encodeURIComponent(kit.handle)}.js`), read(`${root}cart.js`)
        ]);
        const variant = product.variants.find(item => item.id === kit.id);
        if (before.currency !== 'GBP' || product.requires_selling_plan || !variant?.available ||
            variant.price !== 1000 || variant.quantity_rule?.min > 1) {
          throw new Error('The £10 Starter Pack is currently unavailable. Untick it to continue with greens only.');
        }
        if (before.items.some(item => item.variant_id === kit.id)) {
          throw new Error('A Starter Pack is already in your basket. Review your basket or untick this option.');
        }
        if (before.items.some(item => item.product_id === productId && item.selling_plan_allocation)) {
          throw new Error('Your basket includes a greens subscription. Review it before adding a paid Starter Pack.');
        }
        const beforeQuantity = before.items.filter(item => item.variant_id === variantId && !item.selling_plan_allocation)
          .reduce((sum, item) => sum + item.quantity, 0);
        attempted = true;
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }, { id: kit.id, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Basket addition was not confirmed.');
        const after = await read(`${root}cart.js`);
        const kits = after.items.filter(item => item.variant_id === kit.id);
        const greensQuantity = after.items.filter(item => item.variant_id === variantId && !item.selling_plan_allocation)
          .reduce((sum, item) => sum + item.quantity, 0);
        if (after.currency !== 'GBP' || kits.length !== 1 || kits[0].quantity !== 1 ||
            kits[0].selling_plan_allocation || kits[0].original_price !== 1000 ||
            greensQuantity !== beforeQuantity + quantity) {
          throw new Error('The basket changed while adding your items.');
        }
        return after;
      } catch (error) {
        if (attempted) {
          reviewRequired = true;
          error.message = 'We could not confirm the complete addition. Review your basket before trying again.';
        }
        error.reviewRequired = reviewRequired;
        throw error;
      } finally {
        pending = false;
      }
    }
  };
})();
